import React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";

/**
 * PageShell — canonical layout for all Gadget Guy Media 2.0 supporting pages.
 * Renders the locked Phase 2C <Navigation/> (fixed) + <Footer/>. Children get
 * top padding so content clears the 76/80px fixed header.
 *
 * Do NOT introduce a page-specific navigation or footer. If a page has a
 * genuinely different layout requirement (e.g. /robert QR card), it should
 * opt out of this shell rather than duplicating pieces of it.
 */
export const PageShell = ({ children, testId }) => {
  return (
    <div className="min-h-screen" style={{ background: "var(--ggm-navy)" }} data-testid={testId}>
      <Navigation />
      {/* Fixed nav clearance — matches Nav h-[84px] md:h-[92px] */}
      <main style={{ paddingTop: 84 }} className="md:!pt-[92px]">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageShell;
